import KatalLogger from '@amzn/katal-logger';
import { NodeEnv } from 'src/constants';

// In development the `https://74tfwtmc7l.execute-api.eu-west-1.amazonaws.com/prod/v1/log` template never gets replaced with a
// real CloudFormation value, so any logger requests go to a 404. Omit `url`
// in dev so the logger writes to the browser console instead. See KatalLogger
// docs: when `url` is undefined, logs are sent to the console.
//
// logToConsole is OFF in all environments. In production the logs are shipped to
// the KatalLogger endpoint (CloudWatch), and in development they produced a wall
// of structured `Object` entries in the browser console that buried real errors
// and warnings. The info-level messages (linkUpdater, shadow-diff, account-fetch)
// are useful in CloudWatch but not in a developer's console. To re-enable for a
// debugging session, flip this to `true` or call `logger.setLogToConsole(true)`
// in the browser.
const isProduction = process.env.NODE_ENV === NodeEnv.production;

export const logger = new KatalLogger({
  url: isProduction ? 'https://74tfwtmc7l.execute-api.eu-west-1.amazonaws.com/prod/v1/log' : undefined,
  maxLogLineSize: 10000, // default 5000
  logToConsole: false,
});
